import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbDatepickerConfig, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgPipesModule } from 'ngx-pipes';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { UserService } from './shared/user.service';
import { AuthInterceptor } from './auth/auth.interceptor';
import { NgxPrintModule } from 'ngx-print';
import { NgxBarcode6Module } from 'ngx-barcode6';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedMaterialModule } from './shared/SharedMaterial.module';
import { ConfirmDeleteDialogComponent } from './components/confirm-delete-dialog/confirm-delete-dialog.component';

import { GroupedMaterialModule } from './material-module';
import { SearchPatientChangeAcctDialogComponent } from './components/search-patient-change-acct-dialog/search-patient-change-acct-dialog.component';
import { BookingDialogComponent } from './components/booking-dialog/booking-dialog.component';
import { SearchItemCateDialogComponent } from './components/search-item-cate-dialog/search-item-cate-dialog.component';
import { PatientDialogComponent } from './components/patient-dialog/patient-dialog.component';

import { SearchItemIdDialogComponent } from './components/search-item-id-dialog/search-item-id-dialog.component';
import { NewPatientDialogComponent } from './components/patient-dialog/new-patient-dialog/new-patient-dialog.component';
import { DatePipe } from '@angular/common';
import { SearchEmployeeDialogComponent } from './components/search-employee-dialog/search-employee-dialog.component';
import { SearchPatientTypeDialogComponent } from './components/search-patient-type-dialog/search-patient-type-dialog.component';
import { EditBookingDialogComponent } from './components/booking-dialog/edit-booking-dialog/edit-booking-dialog.component';
import { CreateWaitingConsultDialogComponent } from './components/create-waiting-consult-dialog/create-waiting-consult-dialog.component';
import { AppCurrencyPipe, AppCurrencyPipeModule } from './services/CommonService/custom.currency.pipe';
import { registerLocaleData } from '@angular/common';
import localeHK from '@angular/common/locales/zh-Hans-HK';
import { SelectBedNoDialogComponent } from './components/select-bed-no-dialog/select-bed-no-dialog.component';
import { PackageDialogComponent } from './components/package-dialog/package-dialog.component';
import { BillPaymentDialogComponent } from './components/bill-payment-dialog/bill-payment-dialog.component';
import { BillPaymentSearchItemPackageDialogComponent } from './components/bill-payment-search-item-package-dialog/bill-payment-search-item-package-dialog.component';
import { EditWaitingConsultDialogComponent } from './components/edit-waiting-consult-dialog/edit-waiting-consult-dialog.component';
import { ConsultCertComponent } from './print/consult-cert/consult-cert.component';
import { PatientPackageDialogComponent } from './components/patient-package-dialog/patient-package-dialog.component';
import { BillPaymentEhcardNumberComponent } from './components/bill-payment-ehcard-number/bill-payment-ehcard-number.component';
import { BillPaymentPackageTotalAmountComponent } from './components/bill-payment-package-total-amount/bill-payment-package-total-amount.component';
import { BillPaymentChangeAccountDialogComponent } from './components/bill-payment-change-account-dialog/bill-payment-change-account-dialog.component';
import { BillPaymentPrepayDialogComponent } from './components/bill-payment-prepay-dialog/bill-payment-prepay-dialog.component';
import { BillPaymentPackageTotalAmountInputValueDialogComponent } from './components/bill-payment-package-total-amount-input-value-dialog/bill-payment-package-total-amount-input-value-dialog.component';
import { BillpayReceiptCertComponent } from './print/billpay-receipt-cert/billpay-receipt-cert.component';
import { SearchVendorDialogComponent } from './components/search-vendor-dialog/search-vendor-dialog.component';
import { SearchGRNMedDialogComponent } from './components/search-grnmed-dialog/search-grnmed-dialog.component';
import { ChangePayPaymentDialogComponent } from './components/change-pay-payment-dialog/change-pay-payment-dialog.component';
import { PrintPrescriptionComponent } from './print/prescription/prescription.component';
import { BillPaymentWalkinDialogComponent } from './components/bill-payment-walkin-dialog/bill-payment-walkin-dialog.component';
import { InputDiscountDialogComponent } from './components/input-discount-dialog/input-discount-dialog.component';
import { ApiResultDialogComponent } from './components/api-result-dialog/api-result-dialog.component';
import { SickLeaveCertComponent } from './print/sick-leave-cert/sick-leave-cert.component';
import { CustomLetterComponent } from './print/custom-letter/custom-letter.component';
import { MedicalReportComponent } from './print/medical-report/medical-report.component';
import { PrescriptionCertComponent } from './print/prescription-cert/prescription-cert.component';
import { MissingInputPipe } from './services/CommonService/ShowMissingInputMsg.pipe';
import { PrescriptionTagComponent } from './print/prescription-tag/prescription-tag.component';
import { SearchPresDialogComponent } from './components/search-pres-dialog/search-pres-dialog.component';
import { SharedModule } from './shared/SharedModule.module';
import { ShoppingCartPrepayDialogComponent } from './components/shopping-cart-prepay-dialog/shopping-cart-prepay-dialog.component';
import { InvoicePreviewComponent } from './print/invoice-preview/invoice-preview.component';
import { SelectAccCodeDialogComponent } from './components/select-acc-code-dialog/select-acc-code-dialog.component';
import { HttpLoaderFactory } from './shared/HttpLoaderFactory';
import { BillPaymentPrescriptionUpdateDialogComponent } from './components/bill-payment-prescription-update-dialog/bill-payment-prescription-update-dialog.component';
import { AnalysisItemDialogComponent } from './components/analysis-item-dialog/analysis-item-dialog.component';
import { SearchChartAccountDialogComponent } from './components/search-chart-account-dialog/search-chart-account-dialog.component';
import { VoucherSaveComponent } from './components/tRecurrJul-dialog/voucher-save/voucher-save.component';
import { VoucherSearchComponent } from './components/tRecurrJul-dialog/voucher-search/voucher-search.component';
import { SearchAnalysisDialogComponent } from './components/search-analysis-dialog/search-analysis-dialog.component';
import { VoucherComponent } from 'src/app/print/voucher/voucher.component';
import { ImportExportDataResponseDialogComponent } from './components/importExportDataResponse-dialog/importExportDataResponse-dialog.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { BookingCalendarDialogComponent } from './components/booking-calendar-dialog/booking-calendar-dialog.component';
import { Debug_ttp_244_pro_label_printerComponent } from './print/debug_ttp_244_pro_label_printer/debug_ttp_244_pro_label_printer.component';
import { NewPresCopyComponent } from './components/prescription-copy-dialog/new-pres-copy/new-pres-copy.component';
import { SearchPresCopyComponent } from './components/prescription-copy-dialog/search-pres-copy/search-pres-copy.component';
import { CustomDatePickerConfig } from './components/booking-calendar-dialog/CustomDatePickerConfig';
import { LettersComponent } from './print/letters/letters.component';
import { LettersLabelsComponent } from './print/letters/letters-label/letters-label.component';
import { ProcedureFeeComponent } from 'src/app/print/procedure-fee/procedure-fee.component';
import { SearchPoDialogComponent } from './components/search-po-dialog/search-po-dialog.component';
import { MaterialSearchDialogComponent } from './components/material-search-dialog/material-search-dialog.component';
import { DishesSearchDialogComponent } from './components/dishes-search-dialog/dishes-search-dialog.component';
import { PurchaseOrderHardcopyComponent } from './print/purchase-order-hardcopy/purchase-order-hardcopy.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { PaymentHistoryDialogComponent } from './components/payment-history-dialog/payment-history-dialog/payment-history-dialog.component';
import { BillSummaryDialogComponent } from './components/bill-summary-dialog/bill-summary-dialog/bill-summary-dialog.component';
import { ApiResultV2DialogComponent } from './components/api-result-v2-dialog/api-result-v2-dialog.component';
import { PhysioCompletedComponent } from './print/physio-completed/physio-completed.component';
import { XrayCompletedComponent } from './print/xray-completed/xray-completed.component';
import { OCBillpayReceiptCertComponent } from './print/OrthoCentre/OC-billpay-receipt-cert/OC-billpay-receipt-cert.component';
import { PaidChangePayReceiptCertComponent } from './print/paid-change-pay-receipt-cert/paid-change-pay-receipt-cert.component';
import { PatientClinicLabelComponent } from './print/patient-labels/patient-clinic-label/patient-clinic-label.component';
import { PatientMailingLabelComponent } from './print/patient-labels/patient-mailing-label/patient-mailing-label.component';
import { PatientSendOutLabelComponent } from './print/patient-labels/patient-sendOut-label/patient-sendOut-label.component';
import { XrayLabelComponent } from './print/xray-label/xray-label.component';
import { ClinicalNotesComponent } from './print/clinical-notes/clinical-notes.component';
import { PatientHospitalAdmissionComponent } from './print/patient-labels/patient-hospital-admission/patient-hospital-admission.component';

import { ApiMessageDialogComponent } from './components/api-message-dialog/api-message-dialog.component';


registerLocaleData(localeHK);





@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ConfirmDeleteDialogComponent,
    ImportExportDataResponseDialogComponent,
    ApiResultDialogComponent,

    SearchPatientChangeAcctDialogComponent,

    BookingDialogComponent,
    SearchItemCateDialogComponent,
    PatientDialogComponent,

    SearchItemIdDialogComponent,

    SearchEmployeeDialogComponent,

    SearchPatientTypeDialogComponent,

    NewPatientDialogComponent,

    EditBookingDialogComponent,

    CreateWaitingConsultDialogComponent,
    SelectBedNoDialogComponent,
    PackageDialogComponent,
    BillPaymentDialogComponent,
    BillPaymentSearchItemPackageDialogComponent,
    SickLeaveCertComponent,
    CustomLetterComponent,
    PrescriptionCertComponent,
    EditWaitingConsultDialogComponent,
    ConsultCertComponent,
    PatientPackageDialogComponent,
    BillPaymentEhcardNumberComponent,
    BillPaymentPackageTotalAmountComponent,
    BillPaymentChangeAccountDialogComponent,
    BillPaymentPrepayDialogComponent,
    BillPaymentPackageTotalAmountInputValueDialogComponent,
    BillpayReceiptCertComponent,
    OCBillpayReceiptCertComponent,
    PurchaseOrderHardcopyComponent,
    SearchVendorDialogComponent,
    SearchGRNMedDialogComponent,
    ChangePayPaymentDialogComponent,
    PrintPrescriptionComponent,
    BillPaymentWalkinDialogComponent,
    InputDiscountDialogComponent,
    PrescriptionTagComponent,
    VoucherComponent,
    SearchPresDialogComponent,
    ShoppingCartPrepayDialogComponent,
    InvoicePreviewComponent,
    SelectAccCodeDialogComponent,
    BillPaymentPrescriptionUpdateDialogComponent,
    AnalysisItemDialogComponent,
    SearchChartAccountDialogComponent,
    VoucherSaveComponent,
    VoucherSearchComponent,
    SearchAnalysisDialogComponent,
    BookingCalendarDialogComponent,
    Debug_ttp_244_pro_label_printerComponent,
    NewPresCopyComponent,
    SearchPresCopyComponent,
    LettersComponent,
    LettersLabelsComponent,
    ProcedureFeeComponent,
    SearchPoDialogComponent,
    MaterialSearchDialogComponent,
    DishesSearchDialogComponent,
    MedicalReportComponent,
    PaymentHistoryDialogComponent,
    BillSummaryDialogComponent,
    ApiResultV2DialogComponent,
    PhysioCompletedComponent,
    XrayCompletedComponent,
    PaidChangePayReceiptCertComponent,
    PatientClinicLabelComponent,
    PatientMailingLabelComponent,
    PatientSendOutLabelComponent,
    XrayLabelComponent,
    ClinicalNotesComponent,
    PatientHospitalAdmissionComponent,

    ApiMessageDialogComponent

   // XrayComponent,
  //  PhysioComponent
   // DishesPlanComponent,
  //  MaterialListComponent,
  //  MaterialCatComponent,
  //  MaterialComponent,
   // DishesComponent,
   // DishesCatComponent,
  //  BatchNumberEnquiryComponent,
  //  MedicineTypeComponent


  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    BrowserAnimationsModule,
    NgbModule,
    NgPipesModule,
    AppCurrencyPipeModule,
    GroupedMaterialModule,
    FullCalendarModule,
    SharedMaterialModule,
    SharedModule,
    NgxBarcode6Module,
    AngularEditorModule,
    TranslateModule.forRoot(
      {
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }
    )
    ,

    NgxPrintModule

  ],
  providers: [
    AppCurrencyPipe,
    UserService,
    DatePipe,
    MissingInputPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,

    },
    {provide: NgbDatepickerConfig,useClass: CustomDatePickerConfig}],
  bootstrap: [AppComponent],
  entryComponents: [
    ImportExportDataResponseDialogComponent,
    ConfirmDeleteDialogComponent,
    ApiResultDialogComponent,
    ApiResultV2DialogComponent,
    SearchPatientChangeAcctDialogComponent,
    BookingDialogComponent,
    SearchItemCateDialogComponent,
    PatientDialogComponent,
    SearchItemIdDialogComponent,
    SearchPatientTypeDialogComponent,
    NewPatientDialogComponent,
    SearchEmployeeDialogComponent,
    EditBookingDialogComponent,
    CreateWaitingConsultDialogComponent,
    SelectBedNoDialogComponent,
    PackageDialogComponent,
    BillPaymentDialogComponent,
    BillPaymentSearchItemPackageDialogComponent,
    SickLeaveCertComponent,
    CustomLetterComponent,
    EditWaitingConsultDialogComponent,
    ConsultCertComponent,
    PrescriptionCertComponent,
    PatientPackageDialogComponent,
    BillPaymentEhcardNumberComponent,
    BillPaymentPackageTotalAmountComponent,
    BillPaymentPrepayDialogComponent,
    BillPaymentPackageTotalAmountInputValueDialogComponent,
    BillPaymentChangeAccountDialogComponent,
    BillpayReceiptCertComponent,
    OCBillpayReceiptCertComponent,
    PurchaseOrderHardcopyComponent,
    SearchVendorDialogComponent,
    SearchGRNMedDialogComponent,
    ChangePayPaymentDialogComponent,
    PrintPrescriptionComponent,
    BillPaymentWalkinDialogComponent,
    InputDiscountDialogComponent,
    PrescriptionTagComponent,
    VoucherComponent,
    SearchPresDialogComponent,

    ShoppingCartPrepayDialogComponent,
    InvoicePreviewComponent,

    SelectAccCodeDialogComponent,
    BillPaymentPrescriptionUpdateDialogComponent,
    AnalysisItemDialogComponent,
    SearchChartAccountDialogComponent,
    VoucherSaveComponent,
    VoucherSearchComponent,
    SearchAnalysisDialogComponent,
    BookingCalendarDialogComponent,
    NewPresCopyComponent,
    SearchPresCopyComponent,
    Debug_ttp_244_pro_label_printerComponent,
    LettersComponent,
    LettersLabelsComponent,
    ProcedureFeeComponent,
    SearchPoDialogComponent,
    MaterialSearchDialogComponent,
    DishesSearchDialogComponent,
    MedicalReportComponent,
    PaymentHistoryDialogComponent,
    BillSummaryDialogComponent,
    PhysioCompletedComponent,
    XrayCompletedComponent,
    PaidChangePayReceiptCertComponent,
    PatientClinicLabelComponent,
    PatientMailingLabelComponent,
    PatientSendOutLabelComponent,
    XrayLabelComponent,
    ClinicalNotesComponent,
    PatientHospitalAdmissionComponent,
    ApiMessageDialogComponent

  ]
})
export class AppModule { }
